module.exports = __webpack_public_path__ + "static/media/ic_text.db7eaf67.svg";